function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".green{fill:#29ed87;}.black{fill:#2e293a;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-99.222 -0.444)"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "green",
  cx: 21.5,
  cy: 21,
  rx: 21.5,
  ry: 21,
  transform: "translate(99.222 0.444)"
}), /*#__PURE__*/React.createElement("path", {
  className: "black",
  d: "M7,14c-1.876,0-2.127-.008-2.886-.043A3.86,3.86,0,0,1,.042,9.886C.008,9.142,0,8.894,0,7S.008,4.859.042,4.114A3.86,3.86,0,0,1,4.114.043C4.868.008,5.094,0,7,0S9.148.008,9.888.043a3.855,3.855,0,0,1,4.07,4.071C13.992,4.873,14,5.124,14,7s-.008,2.128-.043,2.886a3.857,3.857,0,0,1-4.07,4.071C9.128,13.992,8.877,14,7,14ZM7,1.262c-1.849,0-2.079,0-2.828.039A2.625,2.625,0,0,0,1.3,4.172C1.27,4.89,1.261,5.107,1.261,7S1.27,9.11,1.3,9.828a2.626,2.626,0,0,0,2.87,2.87c.736.034.957.041,2.828.041,1.851,0,2.075-.007,2.829-.041a2.624,2.624,0,0,0,2.87-2.87c.032-.742.039-.964.039-2.828s-.007-2.084-.039-2.828A2.624,2.624,0,0,0,9.829,1.3C9.092,1.27,8.871,1.262,7,1.262Zm0,9.332A3.594,3.594,0,1,1,10.594,7,3.6,3.6,0,0,1,7,10.594ZM7,4.667A2.333,2.333,0,1,0,9.334,7,2.336,2.336,0,0,0,7,4.667ZM10.736,4.1a.84.84,0,1,1,.841-.84A.841.841,0,0,1,10.736,4.1Z",
  transform: "translate(114.222 14.444)"
}));
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.b6cc4b21ea1f7f6ef29da393f84c55e3.svg";
export { ForwardRef as ReactComponent };